import React from "react";

const Loading = () => {
  return <div className="dots-flow"></div>;
};

export default Loading;
